import * as actionTypes from "../actionTypes";
import { updateObject } from "../../shared/utility";

const initialState = {
  loading: false,
  favoriteProducts: null,
  error: null,
};

// Add Product to favorite
const addProductToFavoriteStart = (state: any) => {
  return updateObject(state, { error: null, loading: true });
};

const addProductToFavoriteSuccess = (state: any, action: any) => {
  return updateObject(state, {
    error: null,
    loading: false,
  });
};

const addProductToFavoriteFailed = (state: any, action: any) => {
  return updateObject(state, {
    error: action.error,
    loading: false,
  });
};

// Remove Product to favorite
const removeProductToFavoriteStart = (state: any) => {
  return updateObject(state, { error: null, loading: true });
};

const removeProductToFavoriteSuccess = (state: any, action: any) => {
  return updateObject(state, {
    error: null,
    loading: false,
  });
};

const removeProductToFavoriteFailed = (state: any, action: any) => {
  return updateObject(state, {
    error: action.error,
    loading: false,
  });
};

// get Favorite Products

const getFavoriteProductStart = (state: any) => {
  return updateObject(state, { error: null, loading: true });;
};

const getFavoriteProductSuccess = (state: any, action: any) => {
  return updateObject(state, {
    favoriteProducts: action.favoriteProducts,
    error: null,
    loading: false,
  });
};

const getFavoriteProductFailed = (state: any, action: any) => {
  return updateObject(state, {
    favoriteProducts: null,
    error: action.error,
    loading: false,
  });
};

const favoritesReducer = (state = initialState, action: any) => {
  switch (action.type) {
    // Add Product to favorite
    case actionTypes.ADD_PRODUCT_FAVORITE_START:
      return addProductToFavoriteStart(state);
    case actionTypes.ADD_PRODUCT_FAVORITE_SUCCESS:
      return addProductToFavoriteSuccess(state, action);
    case actionTypes.ADD_PRODUCT_FAVORITE_FAIL:
      return addProductToFavoriteFailed(state, action);
    // Remove Product to favorite
    case actionTypes.REMOVE_PRODUCT_FAVORITE_START:
      return removeProductToFavoriteStart(state);
    case actionTypes.REMOVE_PRODUCT_FAVORITE_SUCCESS:
      return removeProductToFavoriteSuccess(state, action);
    case actionTypes.REMOVE_PRODUCT_FAVORITE_FAIL:
      return removeProductToFavoriteFailed(state, action);
    // get Favorite Products
    case actionTypes.GET_FAVORITE_PRODUCTS_START:
      return getFavoriteProductStart(state);
    case actionTypes.GET_FAVORITE_PRODUCTS_SUCCESS:
      return getFavoriteProductSuccess(state, action);
    case actionTypes.GET_FAVORITE_PRODUCTS_FAIL:
      return getFavoriteProductFailed(state, action);
    default:
      return state;
  }
};

export default favoritesReducer;
